import { assert } from '@sparkdotfi/common-universal'

import { TxOverview } from '../logic/createTxOverview'
import { SuccessViewPanelTitle } from '@/features/dialogs/common/components/success-view/SuccessPanelTitle'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '@/features/dialogs/common/components/success-view/SuccessViewContent'
import { SuccessViewPanel } from '@/features/dialogs/common/components/success-view/SuccessViewPanel'
import { SuccessViewProceedButton } from '@/features/dialogs/common/components/success-view/SuccessViewProceedButton'
import { SuccessViewTokenRow } from '@/features/dialogs/common/components/success-view/SuccessViewTokenRow'
import { testIds } from '@/ui/utils/testIds'

export interface SuccessViewProps {
  txOverview: TxOverview
  onProceed: () => void
  proceedText: string
}
export function SuccessView({ txOverview, onProceed, proceedText }: SuccessViewProps) {
  assert(txOverview.status === 'success', 'txOverview should be success when on success view')
  return (
    <SuccessViewContent>
      <SuccessViewCheckmark />
      <SuccessViewPanel data-testid={testIds.dialog.success}>
        <SuccessViewPanelTitle>Converted from</SuccessViewPanelTitle>
        <SuccessViewTokenRow token={txOverview.from} amount={txOverview.outcome.value} />
        <SuccessViewPanelTitle>To</SuccessViewPanelTitle>
        <SuccessViewTokenRow token={txOverview.outcome.token} amount={txOverview.outcome.value} />
      </SuccessViewPanel>
      <SuccessViewProceedButton onProceed={onProceed}>{proceedText}</SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
